import { useStaticQuery } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";
import citiesMap from "../Map/cities-data.js";
import { format, isAfter } from "date-fns";
import Link from "../../utils/Link";
import "./style.scss";

export const query = graphql`
  query {
    api {
      jobVacancies(
        sort: "expirationDate:asc"
        where: { expirationDate_gte: "2021-04-17T21:14:05.494Z" }
      ) {
        id
        slug
        title {
          id
          text_sq
          text_en
        }
        expirationDate
        city
      }
    }
  }
`;

const JobVacancies = () => {
  const apiData = useStaticQuery(query);
  const jobs = apiData.api.jobVacancies;
  const { t } = useTranslation();

  return (
    <div className="accounts-row__wrap">
      {jobs
        .filter((job) => {
          const expirationDate = new Date(job.expirationDate);
          const now = new Date();

          return isAfter(expirationDate, now);
        })
        .map((job) => {
          return (
            <article class="job-item">
              <Link to={`/job/${job.slug}`}>
                <header>{text(job.title)}</header>
                <span>
                  {citiesMap[job.city]} &bull; {t("jobVacancies.closingDate")}{" "}
                  {format(new Date(job.expirationDate), "dd/MM/yyyy")}
                </span>
              </Link>
            </article>
          );
        })}
    </div>
  );
};

export default JobVacancies;
